import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

import {useResponsive} from 'src/hooks/use-responsive';

import {CloseIcon} from '@components/lightbox';

// ----------------------------------------------------------------------

type Props = {
  title: string;
  onCloseDetails: VoidFunction;
};

export default function DialogToolBar({title, onCloseDetails}: Props) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        p: theme => theme.spacing(2.5, 1, 2.5, 2.5)
      }}>
      <h3 style={{marginRight: '-0.5vh'}}> {title}</h3>
      <Stack direction="row" justifyContent="flex-end" flexGrow={1}>
          <Tooltip title="Back">
            <IconButton
              aria-label="close"
              onClick={onCloseDetails}
              sx={{mr: 1}}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
      </Stack>
    </Stack>
  );
}
